import React, {Component} from 'react';
import {Button} from 'antd';
import SystemHubUpgradeStationModalForm from './SystemHubUpgradeStationModalForm';

class SystemHubButtonUpgrade extends Component {
  state = {
    visible: false
  };
  showModal = () => {
    this.setState({visible: true});
  };
  handleCancel = () => {
    this.setState({visible: false});
  };
  handleUpdate = () => {
    const form = this.form;
    const {stations, hub} = this.props
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {selectedKeys, download} = values
      const hardwareIDs = stations.filter((item) => {
        return selectedKeys.findIndex((id) => id === item.ID) > -1
      }).map((item) => {
        return item.HardwareID
      })
      const upgradeList = {
        ID: hub.ID,
        FirmwareDownloadEnable: download,
        ActiveDownloadLimits: hardwareIDs
      }
      this.props.onUpgrade(upgradeList)
      form.resetFields();
      this.setState({visible: false});
    });
  };
  saveFormRef = (form) => {
    this.form = form;
  };
  render() {
    const {hub, stations, groups} = this.props
    return (<span>
      <Button onClick={this.showModal} type="primary" ghost="ghost" size="small" icon="fork">
        Upgrage
      </Button>
      <SystemHubUpgradeStationModalForm title="Chọn trạm nâng cấp firmware" hub={hub} stations={stations} groups={groups} ref={this.saveFormRef} visible={this.state.visible} onCancel={this.handleCancel} onSubmit={this.handleUpdate}/>
    </span>);
  }
}

export default SystemHubButtonUpgrade;



// WEBPACK FOOTER //
// ./src/components/SystemHubButtonUpgrade.js